import React from 'react';
import { graphql } from 'gatsby';
import { OmTabsTwoColumnLayoutImageLeft } from '@om/component-library-react';
import TwoColumnImageLeft from './TwoColumnImageLeft';

const TabsTwoColumnImageLeft = ({
    tabsTwoColumnImageLeftContent,
    slot
}) => {
    if(!tabsTwoColumnImageLeftContent) {
        return '';
    }

    const {
        use_heading_as_h1,
        is_extended,
        has_boundary,
        section_heading,
        section_caption,
        tab_text_one,
        om_two_column_image_left_one,
        tab_text_two,
        om_two_column_image_left_two,
        tab_text_three,
        tab_text_four,
        tab_text_five,
        tab_text_six,
        button_action_type,
        call_me_back,
        button_text,
        open_tab,
        button_url,
        om_two_column_image_left_three,
        om_two_column_image_left_four,
        om_two_column_image_left_five,
        om_two_column_image_left_six
    } = tabsTwoColumnImageLeftContent;

    return (
        <OmTabsTwoColumnLayoutImageLeft
            slot={slot}
            isExtended={is_extended}
            hasBoundary={has_boundary}
            tabTextOne={tab_text_one}
            tabTextTwo={tab_text_two}
            tabTextThree={tab_text_three}
            tabTextFour={tab_text_four}
            tabTextFive={tab_text_five}
            tabTextSix={tab_text_six}
            buttonText={button_text}
            buttonUrl={button_url ? button_url.href : ''}
            buttonActionType={button_action_type}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            openTab={open_tab}
        >
            {
                use_heading_as_h1 ? <h1 slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} /> :  <span slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} />
            }
            {
                section_caption ? <span slot="section-caption" dangerouslySetInnerHTML={{__html: section_caption}} /> : ''
            }
            <TwoColumnImageLeft slot="om-two-column-image-left-one" twoColumnImageLeftContent={om_two_column_image_left_one[0]} />
            <TwoColumnImageLeft slot="om-two-column-image-left-two" twoColumnImageLeftContent={om_two_column_image_left_two[0]} />
            <TwoColumnImageLeft slot="om-two-column-image-left-three" twoColumnImageLeftContent={om_two_column_image_left_three[0]} />
            <TwoColumnImageLeft slot="om-two-column-image-left-four" twoColumnImageLeftContent={om_two_column_image_left_four[0]} />
            <TwoColumnImageLeft slot="om-two-column-image-left-five" twoColumnImageLeftContent={om_two_column_image_left_five[0]} />
            <TwoColumnImageLeft slot="om-two-column-image-left-six" twoColumnImageLeftContent={om_two_column_image_left_six[0]} />
        </OmTabsTwoColumnLayoutImageLeft>
    );
};

export const pageQuery = graphql`
fragment TabsTwoColumnLayoutImageLeft on Contentstack_tabs_2_col_layout_image_left {
        uid
        use_heading_as_h1
        is_extended
        has_boundary
        section_heading
        section_caption
        tab_text_one
        om_two_column_image_left_one {
            ...TwoColumnImageLeft
        }
        tab_text_two
        om_two_column_image_left_two {
            ...TwoColumnImageLeft
        }
        tab_text_three
        tab_text_four
        tab_text_five
        tab_text_six
        button_action_type
        call_me_back {
            ...CallMeBack
        }
        button_text
        open_tab
        button_url {
            ...Link
        }
        om_two_column_image_left_three {
            ...TwoColumnImageLeft
        }

        om_two_column_image_left_four {
            ...TwoColumnImageLeft
        }
        om_two_column_image_left_five {
            ...TwoColumnImageLeft
        }
        om_two_column_image_left_six {
            ...TwoColumnImageLeft
        }
    }
`;

export default TabsTwoColumnImageLeft